import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const block1config: Record<string, FormConfigProps> = {
  bigText: {
    label: 'tekstai parengiami stambiu šriftu, plačiu intervalu',
    value: 'bigText',
  },
  simplifiedContent: {
    label: 'teksto turinys supaprastinamas, išlaikant esminę informaciją',
    value: 'simplifiedContent',
  },
  colorCoded: {
    label: 'tekste skirtingomis spalvomis pažymima esminė informacija',
    value: 'colorCoded',
  },
  pictureContent: {
    label: 'tekstai papildomi iliustracijomis / simboliais / schemomis',
    value: 'pictureContent',
  },
  logicallyDivided: {
    label: 'tekstai skaidomi į loginius vienetus',
    value: 'logicallyDivided',
  },
  studentSpecific: {
    label: 'tekstai pritaikomi atsižvelgiant į mokinio pomėgius',
    value: 'studentSpecific',
  },
  audioFormatContent: {
    label: 'tekstai pateikiami garsiniu formatu',
    value: 'audioFormatContent',
  },
  specAudioTools: {
    label: 'ugdomoji medžiaga įgarsinama naudojantis:',
    value: 'specAudioTools',
    children: {
      recorder: {
        label: 'diktofonu',
        value: 'recorder',
        paddingLeft: 24,
      },
      textToSpeech: {
        label: 'programine funkcija iš teksto į kalbą',
        value: 'textToSpeech',
        paddingLeft: 24,
      },
      speechToText: {
        label: 'programinė funkcija iš kalbos į tekstą',
        value: 'speechToText',
        paddingLeft: 24,
      },
      smartPen: {
        label: 'išmaniuoju skaitomuoju rašikliu',
        value: 'smartPen',
        paddingLeft: 24,
      },
      hearingAid: {
        label: 'įrašanti ir įrašą įgarsinanti priemonė',
        value: 'hearingAid',
        paddingLeft: 24,
      },
      otherSpecAudioTool: {
        isInput: true,
        label: 'kita:',
        value: 'otherSpecAudioTool',
        paddingLeft: 24,
      },
    },
  },
  guiContent: {
    label: 'ugdomoji medžiaga pateikiama grafinėje tvarkyklėje',
    value: 'guiContent',
  },
  videoContent: {
    label: 'ugdomoji medžiaga pateikiama vaizdiniu formatu',
    value: 'videoContent',
  },
  visualContent: {
    label: 'vaizdinė medžiaga parenkama pagal abstraktumo lygį',
    value: 'visualContent',
  },
  otherEduMaterialNeeds: {
    isInput: true,
    label: 'kita:',
    value: 'otherEduMaterialNeeds',
  },
};

export const Block1 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 1 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Ugdomosios medžiagos pritaikymas:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={block1config}
          formPathParams={['subject', 'block1']}
          form={form}
        />
      </div>
    );
  },
);
